module.exports = __webpack_public_path__ + "static/media/new-indian-express.34899d1d.png";